import axiosInstance from "./service-instance";

class QuestionareServiceGenerator {
    getQuestionare = () =>
        axiosInstance.get("/master/question/list/", {
            headers: {
                "Content-Type": "application/json"
            },
            params: {
                paginate: false
            }
        });
    getAnswersForQuestionare = caseId =>
        axiosInstance.get(`/case/${caseId}/questionnaire/`, {
            headers: {
                "Content-Type": "application/json"
            }
        });
    postAnswersForQuestionare = (caseId, data) =>
        axiosInstance.post(`/case/${caseId}/questionnaire/`, data, {
            headers: {
                "Content-Type": "application/json"
            }
        });
    
    refreshPDQuestionnaire = (caseId) =>
        axiosInstance.put(`/case/${caseId}/questionnaire-refresh/`,
            { 
                headers:{
                    "Content-Type": "application/json"
                }
            }
        )
            .then(
                ({data}) => {
                    return Promise.resolve(data);
                }
            );
    
}

export default new QuestionareServiceGenerator();
